import { Component } from '@angular/core'

@Component({
  selector: 'app-input-container',
  template: ` <div class="input-container"><ng-content></ng-content></div> `,
  styleUrls: ['./input-container.component.scss'],
})
export class InputContainerComponent {}
